import { Lightbulb } from 'lucide-react'

export default function NichesDisplay({ niches }) {
  const getOpportunityLevel = (score) => {
    if (score >= 90) return '🔥 EXCELENTE'
    if (score >= 80) return '✨ MUY BUENA'
    if (score >= 70) return '⭐ BUENA'
    return '👍 VIABLE'
  }

  const getOpportunityColor = (opportunity) => {
    switch(opportunity) {
      case 'EXCELLENT':
        return 'text-slate-lighter'
      case 'VERY GOOD':
        return 'text-slate-light'
      case 'GOOD':
        return 'text-slate-medium'
      default:
        return 'text-slate-light'
    }
  }

  return (
    <div className="gradient-glow p-6 rounded-xl card-hover">
      <div className="flex items-center gap-3 mb-6">
        <Lightbulb className="w-6 h-6 text-slate-lighter" />
        <h3 className="text-xl font-bold text-white">Nichos Sin Explotar 🎯</h3>
      </div>

      <div className="space-y-4">
        {niches.map((niche, idx) => (
          <div 
            key={idx}
            className="p-4 bg-slate-darker border border-slate-lighter/30 rounded-lg hover:border-slate-lighter/60 hover:shadow-lg hover:shadow-slate-lighter/20 transition-all"
          >
            <div className="flex items-start justify-between mb-3">
              <div>
                <h4 className="font-bold text-white text-lg">{niche.name}</h4>
                <p className="text-sm text-slate-light">Sub-nicho especifico con alto potencial</p>
              </div>
              <span className="text-3xl font-bold text-slate-lighter">{niche.score}/100</span>
            </div>

            <div className="grid grid-cols-3 gap-3 mb-4">
              <div className="p-3 bg-slate-lighter/10 rounded-lg border border-slate-lighter/20">
                <p className="text-xs text-slate-light mb-1">Profesionales</p>
                <p className="font-bold text-slate-lighter">{niche.professionals}</p>
              </div>
              <div className="p-3 bg-slate-light/10 rounded-lg border border-slate-light/20">
                <p className="text-xs text-slate-light mb-1">Demanda</p>
                <p className="font-bold text-slate-light">MUY ALTA</p>
              </div>
              <div className="p-3 bg-slate-medium/10 rounded-lg border border-slate-medium/20">
                <p className="text-xs text-slate-light mb-1">Oportunidad</p>
                <p className={`font-bold ${getOpportunityColor(niche.opportunity)}`}>
                  {niche.opportunity === 'EXCELLENT' ? '🔥 MAX' : niche.opportunity === 'VERY_GOOD' ? '✨ ALT' : '⭐ MED'}
                </p>
              </div>
            </div>

            <div className="flex items-center justify-between p-3 bg-slate-lighter/5 rounded-lg border border-slate-lighter/20">
              <div>
                <p className="text-sm text-slate-300">
                  <span className="font-semibold text-slate-lighter">Estado:</span> {getOpportunityLevel(niche.score)}
                </p>
              </div>
              <button className="px-4 py-2 bg-slate-lighter/20 hover:bg-slate-lighter/30 text-slate-lighter rounded-lg transition-all font-semibold text-sm">
                📍 Investigar
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-slate-darker rounded-lg border border-slate-light/20">
        <p className="text-sm text-slate-300">
          <span className="font-semibold text-slate-lighter">💡 Nichos sin Explotar:</span> Estos sub-nichos tienen demanda comprobada pero baja competencia. Son la mejor oportunidad para entrar rápido. Especialízate en uno de estos primero para construir autoridad.
        </p>
      </div>
    </div>
  )
}
